import Box from "@routes/Article/components/ArticleParagraphElements/storyElement/box/Box";
import BoxTitle from "@routes/Article/components/ArticleParagraphElements/storyElement/box/BoxTitle";
import DataWrapper from "@routes/Article/components/ArticleParagraphElements/storyElement/DataWrapper";
import DynamicIframe from "@routes/Article/components/ArticleParagraphElements/storyElement/DynamicIframe";
import Embed from "@routes/Article/components/ArticleParagraphElements/storyElement/embed/Embed";
import Graphic from "@routes/Article/components/ArticleParagraphElements/storyElement/Graphic";
import InlineBrightcove from "@routes/Article/components/ArticleParagraphElements/storyElement/InlineBrightcove";
import InlineImage from "@routes/Article/components/ArticleParagraphElements/storyElement/InlineImage";
import InlinePodcast from "@routes/Article/components/ArticleParagraphElements/storyElement/InlinePodcast";
import InlineYoutube from "@routes/Article/components/ArticleParagraphElements/storyElement/InlineYoutube";
import ListBulleted from "@routes/Article/components/ArticleParagraphElements/storyElement/ListBulleted";
import ListNumbered from "@routes/Article/components/ArticleParagraphElements/storyElement/ListNumbered";
import ParagraphWrapper from "@routes/Article/components/ArticleParagraphElements/storyElement/ParagraphWrapper";
import PullQuote from "@routes/Article/components/ArticleParagraphElements/storyElement/PullQuote";
import Subheading from "@routes/Article/components/ArticleParagraphElements/storyElement/Subheading";
import Table from "@routes/Article/components/ArticleParagraphElements/storyElement/Table";
import { Type } from "@typings/enums";

/**
 * Factory function to create article elements based on their type.
 * This function maps different types to their corresponding React components.
 */
export const ArticleElementsFactory = (type: Type) => {
  switch (type) {
    case Type.ListBulleted:
      return ListBulleted;

    case Type.ListNumbered:
      return ListNumbered;

    case Type.SubHead:
      return Subheading;

    case Type.Paragraph:
      return ParagraphWrapper;

    case Type.Image:
      return InlineImage;

    case Type.BrightcoveVideo:
      return InlineBrightcove;

    case Type.PodcastWrapper:
    case Type.OmnyPodcast:
      return InlinePodcast;

    case Type.DataWrapper:
      return DataWrapper;

    case Type.Embed:
      return Embed;

    case Type.PullQuote:
      return PullQuote;

    case Type.Table:
      return Table;

    case Type.Graphic:
      return Graphic;

    case Type.Box:
      return Box;

    case Type.BoxTitle:
      return BoxTitle;

    case Type.YoutubeVideo:
      return InlineYoutube;

    case Type.DynamicIframeWrapper:
      return DynamicIframe;
  }
};
